"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarDay = exports.CalendarSlot = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var CalendarSlot = _propTypes.default.shape({
  id: _propTypes.default.string.isRequired,
  day: _propTypes.default.number.isRequired,
  from: _propTypes.default.objectOf(_propTypes.default.string),
  till: _propTypes.default.objectOf(_propTypes.default.string),
  fromError: _propTypes.default.string,
  tillError: _propTypes.default.string
});

exports.CalendarSlot = CalendarSlot;

var CalendarDay = _propTypes.default.shape({
  id: _propTypes.default.number.isRequired,
  dayName: _propTypes.default.string.isRequired,
  enabled: _propTypes.default.bool.isRequired,
  slots: _propTypes.default.arrayOf(CalendarSlot).isRequired
});

exports.CalendarDay = CalendarDay;